export default __webpack_public_path__ + "static/1920X938_SLIDER_NIE_SZUKAJ_DZIURY_W_CALYM-fb8bd307cae09c61dd4b4838084e449b.jpg";